export const renderStrictTags = (text: string) => `${text}`;
